"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importDefault(require("react"));
function CheckIcon({ checked }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { className: classnames_1.default(checked === true
                ? 'text-info'
                : checked === false
                    ? 'text-dark'
                    : 'text-muted'), icon: checked === true
                ? pro_light_svg_icons_1.faCheck
                : checked === false
                    ? pro_light_svg_icons_1.faTimes
                    : pro_light_svg_icons_1.faSquareFull })));
}
exports.CheckIcon = CheckIcon;
//# sourceMappingURL=CheckIcon.js.map